module.exports = __webpack_public_path__ + "img/help_dataset_overview2.d18ea05a.png";